import React from "react";
// import { BackIcon, CloseIcon } from "../../../components/Icons";
import { StyledBookingFlowButton } from "../../containers/BookingScheduleContainer/BookingScheduleContainer.style";
import { useBookingAppointmentTypeStore } from "../../../hooks";
import { useAppointmentStore } from "../../../hooks/redux-hooks/appointment-store/appointment.store";
import { MODALS } from "../../../config/params";
import { useModal } from "../../../context/ModalContext";

interface IConfirmDoctorVisitToggleContainer{
  setActiveStep: (step: number) => void;
  setSelectedReasons: (reasonList: string[]) => void;
}

const ConfirmDoctorVisitToggleContainer = ({
  setActiveStep, setSelectedReasons,
}: IConfirmDoctorVisitToggleContainer) => {
  const { setDefaultBookingType } = useBookingAppointmentTypeStore();
  const { setAppointmentsForm, setReasonForVisit, setPromoCodeData } = useAppointmentStore();
  const { openModal } = useModal();

  const handleContinueExpressCta = () => {
    setReasonForVisit({});
    setSelectedReasons([]);
    setActiveStep(1);
  };

  const handleConfirmDoctorVisit = () => {
    setDefaultBookingType();
    setAppointmentsForm(null);
    setReasonForVisit({});
    setPromoCodeData([]);
    openModal(MODALS.UPDATED_BOOK_A_VISIT_MODAL);
  };

  return (
    <div className="flex flex-col justify-between h-full">
      <div className="flex items-center h-full">
        <div className="">
          <div>
            <img
              className="max-h-44 max-w-44 mx-auto"
              alt="confirm_dropoff_icon"
              src="/assets/icons/account-alert.png"
            />
          </div>
          <div className="text-2xl font-bold text-center mt-2">
            Book a Doctor Visit?
          </div>
          <p className="text-light-black text-center mt-1.5 px-10">
          Switching to a doctor visit will cancel your express booking.
          You’ll have to choose a new time based on Doctor availability. What would you like to do?
          </p>
        </div>
      </div>
      <div className="space-y-3 text-center">
        <StyledBookingFlowButton
          color="primary"
          size="small"
          className="w-full"
          onClick={handleConfirmDoctorVisit}
        >
          Book a Doctor Visit
        </StyledBookingFlowButton>
        <StyledBookingFlowButton
          onClick={handleContinueExpressCta}
          color="primary"
          size="small"
          className="!bg-transparent !border !border-light-black !text-black w-full hover:!bg-gray-3"
        >
          Continue Booking Express Services
        </StyledBookingFlowButton>
      </div>
    </div>
  );
};

export default ConfirmDoctorVisitToggleContainer;
